// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Q4K1","image":"Header_image__f8zvm","name":"Header_name__3CmCD","info":"Header_info__5BIo_","infoRow":"Header_infoRow__1tso9"};